import reducer from './reducer';
import saga from './saga';

export { reducer, saga };



// WEBPACK FOOTER //
// ./src/store/modules/faq/index.ts